import { FaChurch, FaLandmark, FaPalette, FaHandsHelping } from 'react-icons/fa';

/**
 * Icono por defecto (sin logo) según variante de perfil de entidad en Cadencya.
 * @param {string} [variante] RELIGIOSO | AYUNTAMIENTO | ASOCIACION_CULTURAL | OTRO
 * @returns {import('react-icons').IconType}
 */
export function getCofradiaPlaceholderIcon(variante) {
  switch (variante) {
    case 'AYUNTAMIENTO':
      return FaLandmark;
    case 'ASOCIACION_CULTURAL':
      return FaPalette;
    case 'OTRO':
      return FaHandsHelping;
    case 'RELIGIOSO':
    default:
      return FaChurch;
  }
}
